import { useCallback, useEffect, useState } from "react";
import PaymentHistoryService from "../../../../../../../../../services/accounts/paymentHistory";

export const useFetchData = (contractId: string) => {
  const [isLoading, setIsLoading] = useState<boolean>(true);

  const [data, setData] = useState<any>(null);

  const fetchData = useCallback(async () => {
    try {
      const res = await PaymentHistoryService.fetchTotals({ contractId });

      setData(res);

      setIsLoading(false);
    } catch {
      setIsLoading(false);
    }
  }, [contractId]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return { data, isLoading };
};
